import { createOrganization } from 'api/organizations.api';
import { updateUser } from 'api/users.api';
import { $form, $user, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';
import getSelectValue from 'utils/getSelectValue';

export const handleSubmitOnboarding = async () => {
  $view.update({
    isLoading: true,
  });

  try {
    const organization = await createOrganization({
      name: $form.value.companyName,
      email: $user.value.email,
      typeId: getSelectValue($form.value.userType),
    });
    await updateUser($user.value.id, {
      firstName: $form.value.firstName,
      lastName: $form.value.lastName,
      email: $form.value.email,
      userTypeId: getSelectValue($form.value.userType),
      onboardingStep: 'completed',
      organizationId: organization.id,
    });
    const userType = getSelectValue($form.value.userType) === 1 ? 'founder' : 'investor';
    window.location.href = `/${userType}/settings`;
  } catch (error) {
    displayError({
      message: 'Failed to complete onboarding. Please check your information and try again.',
      title: 'Onboarding Error',
    });
  } finally {
    $view.update({
      isLoading: false,
    });
  }
};
